export default {
  // General
  'About {appName}': 'Par {appName}',
  'About Enable Banking API': 'Par Enable Banking API',
  'Application description is not provided.': 'Lietojumprogrammas apraksts nav sniegts.',
  'Authenticate': 'Autentificēt',
  'Authentication method': 'Autentifikācijas metode',
  'Authentication session has expired': 'Autentifikācijas sesija ir beigusies',
  'Cancel': 'Atcelt',
  'Click {0} button if you have confirmed authorization in the BankID app.': 'Noklikšķiniet uz pogas {0}, ja esat apstiprinājis autorizāciju lietotnē BankID.',
  'Continue authentication': 'Turpināt autentifikāciju',
  'Cookies must be enabled in your browser to continue': 'Lai turpinātu, pārlūkprogrammā ir jāiespējo sīkfaili',
  'Enter your OTP code with index {0}': 'Ievadiet savu OTP kodu ar indeksu {0}',
  'Error during authentication:': 'Kļūda autentifikācijas laikā:',
  'Error while updating authentication status': 'Atjauninot autentifikācijas statusu, radās kļūda',
  'OTP code': 'OTP kods',
  'Open the BankID app on this device': 'Šajā ierīcē atveriet lietotni BankID',
  'Redirecting to your account servicing provider': 'Notiek novirzīšana uz jūsu konta apkalpošanas nodrošinātāju',
  'Returning to the authentication initiator': 'Atgriešanās pie autentifikācijas ierosinātāja',
  'Start the BankID app on your mobile device and tap the QR code button in the app to scan the QR code on this page': 'Sāciet lietotni BankID savā mobilajā ierīcē un pieskarieties pogai QR kods, lai skenētu QR kodu šajā lapā',
  'or': 'vai',
  'Starting authorization': 'Sāk autorizāciju',
  'To continue please use your authentication app': 'Lai turpinātu, lūdzu, izmantojiet savu autentifikācijas lietotni',
  'Try again': 'Mēģini vēlreiz',
  'Submit': 'Iesniedziet',
  'Unable to access server': 'Nevar piekļūt serverim',
  'Unable to authenticate': 'Nevar autentificēt',
  'Unable to continue authorization': 'Nevar turpināt autorizāciju',
  'Unable to continue decoupled authorization': 'Nevar turpināt atsaistīto autorizāciju',
  'Unable to handle authentication status "{status}"': 'Nevar apstrādāt autentifikācijas statusu "{status}"',
  'Unknown error occurred': 'Radās nezināma kļūda',
  'You need to close this window': 'Jums ir jāaizver šis logs',
  'Authentication cancelled': 'Autentifikācija atcelta',
  // Consent
  'Authentication is initiated by {0}.': 'Autentifikāciju ierosina {0}.',
  'After you complete authentication, {0} will be shared with the authentication initiator.': 'Pēc autentifikācijas pabeigšanas {0} tiks kopīgoti ar autentifikācijas ierosinātāju.',
  'your payment accounts data': 'jūsu maksājumu kontu dati',
  'the list of your payment accounts': 'jūsu maksājumu kontu sarakstu',
  'the list of your payment accounts and accounts balances': 'jūsu maksājumu kontu saraksts un kontu atlikumi',
  'the list of your payment accounts and accounts transactions': 'jūsu maksājumu kontu sarakstu un kontu transakcijas',
  'the list of your payment accounts, accounts balances and transactions': 'jūsu maksājumu kontu, kontu atlikumu un darījumu saraksts',
  'By pressing {0} button you agree with the {1}.': 'Nospiežot pogu {0}, jūs piekrītat {1}.',
  'Press {0} button if you are not willing to share your payment accounts data.': 'Nospiediet pogu {0}, ja nevēlaties kopīgot maksājumu kontu datus.',
  // Payment consent
  'Payment details': 'Maksājumu informācija',
  'Payment ID provided by the application: {0}': 'Lietojumprogrammas nodrošinātais maksājuma ID: {0}',
  'Account number where to transfer funds: {0}': 'Konta numurs, uz kuru pārskaitīt līdzekļus: {0}',
  'Payee name in the payment: {0}': 'Maksājuma saņēmēja vārds maksājumā: {0}',
  'Payee country: {0}': 'Maksājuma saņēmēja valsts: {0}',
  'Payment amount: {0}': 'Maksājuma summa: {0}',
  'Message or reference number in the payment: {0}': 'Ziņojums vai atsauces numurs maksājumā: {0}',
  'Payment is initiated by {0}.': 'Maksājumu ierosina {0}.',
  'After you complete authentication, your payment consent will be requested by your account servicing payment service provider.': 'Pēc autentifikācijas pabeigšanas jūsu kontu apkalpojošais maksājumu pakalpojumu sniedzējs pieprasīs jūsu maksājuma piekrišanu.',
  'terms of service': 'pakalpojumu sniegšanas noteikumi',
  'Press {0} button if you are not willing to complete this payment.': 'Nospiediet pogu {0}, ja nevēlaties pabeigt šo maksājumu.',
  'Select Payment Account': 'Atlasiet maksājumu konts',
  'Confirm': 'Apstiprināt',
  // Backend messages
  '10 digit client number': '10 ciparu klienta numurs',
  '10 digit organisation number (or 12 digit personal number if the company is a sole proprietorship)': '10 ciparu organizācijas numurs (vai 12 ciparu personas numurs, ja uzņēmums ir individuālais uzņēmums)',
  '10 digit organization number.': '10 ciparu organizācijas numurs.',
  '17 digit card number (starting with 6703)': '17 ciparu kartes numurs (sākot ar 6703)',
  '6 digit Handelsbanken customer number': '6 ciparu Handelsbanken klienta numurs',
  '8 digits CVR number': '8 ciparu CVR numurs',
  '9 digits Organisasjonsnummer': '9 cipari Organisasjonsnummer',
  'Agreement number': 'Līguma numurs',
  'Agreement number for Nordea Corporate Netbank': 'Nordea korporatīvās internetbankas līguma numurs',
  'Bank user ID': 'Bankas lietotāja ID',
  'Business identity code (Y-tunnus) in 1234567-8 format': 'Uzņēmuma identifikācijas kods (Y-tunnus) 1234567-8 formātā',
  'Business identity code which is displayed in the Corporate Internet bank settings': 'Uzņēmuma identifikācijas kods, kas tiek parādīts korporatīvās internetbankas iestatījumos',
  'Client ID': 'Klienta ID',
  'Client number': 'Klienta numurs',
  'Company ID': 'Uzņēmuma ID',
  'Company number': 'Uzņēmuma numurs',
  'Corporate ID': 'Uzņēmuma ID',
  'Corporate registration ID': 'Uzņēmuma reģistrācijas ID',
  'Currency code': 'Valūtas kods',
  'Digit card number': 'Ciparu kartes numurs',
  'Disposer': 'Iznīcinātājs',
  'E-mail': 'E-pasts',
  'E-mail used for authenticating to Holvi': 'Holvi autentifikācijai izmantotais e-pasts',
  'Either the 14 digit SEB identifier for the company or the 10 digit organization number': 'Uzņēmuma 14 ciparu SEB identifikators vai 10 ciparu organizācijas numurs',
  'FKDN (without subaccount number): 3 digit branch number + 7 digit customer number': 'FKDN (bez subkonta numura): 3 ciparu filiāles numurs + 7 ciparu klienta numurs',
  'For Swedish Corporates, this is their Organisation number or SHB number, and for Sole Traders (Enskild firma), it is their Personal number, all of which are 10 digits.': 'Zviedrijas uzņēmumiem tas ir organizācijas numurs vai SHB numurs, savukārt individuālajiem tirgotājiem (Enskild firma) tas ir viņu personīgais numurs, kas visi sastāv no 10 cipariem.',
  'IBAN': 'IBAN',
  'ID, NIE, Passport': 'ID, NIE, pase',
  'Login ID used in MyBRD aplications': 'MyBRD lietojumprogrammās izmantotais pieteikšanās ID',
  'Login Name': 'Lietotāja vārdu',
  'Mandate ID': 'Mandāta ID',
  'Norwegian national identity number in the format DDMMYYXXXXX (11 digits)': 'Norvēģijas valsts identifikācijas numurs formātā DDMMYYXXXXX (11 cipari)',
  'Online banking PIN': 'Internetbankas PIN',
  'Online banking Password': 'Internetbankas parole',
  'Organisation ID in the format TBxxxxx or TXxxxxx': 'Organizācijas ID formātā TBxxxxx vai TXxxxxx',
  'Organisation number': 'Organizācijas numurs',
  'PIN': 'PIN',
  'Password': 'Parole',
  'Password for Aktia Internet bank': 'Aktia internetbankas parole',
  'Password used for authenticating to Holvi': 'Parole, kas izmantota autentifikācijai Holvi',
  'Personal ID': 'Personas ID',
  'Personal ID number': 'Personas kods',
  'Personal code': 'Personas kods',
  'Personal code of the user': 'Lietotāja personas kods',
  'Personal signatory number': 'Personīgais paraksta numurs',
  'Personal username for online banking': 'Personīgais lietotājvārds internetbankai',
  'Postbank ID': 'Pasta bankas ID',
  'Social security number (Personnummer)': 'Sociālās apdrošināšanas numurs (personas numurs)',
  'Social security number in the format YYYYMMDDXXXX': 'Sociālās apdrošināšanas numurs šādā formātā: GGGGMMDDXXXX',
  'Swedish social security number in the format YYYYMMDDXXXX': 'Zviedrijas sociālās apdrošināšanas numurs šādā formātā: GGGGMMDDXXXX',
  'The IBAN of the user authenticating': 'Lietotāja autentifikācijas IBAN',
  'The currency code': 'Valūtas kods',
  'The user ID of the user authenticating': 'Lietotāja autentifikācijas lietotāja ID',
  'Unique personal ID number': 'Unikāls personas kods',
  'User ID': 'Lietotāja ID',
  'User ID for Aktia Internet bank': 'Aktia internetbankas lietotāja ID',
  'User ID for Nordea Corporate Netbank': 'Nordea korporatīvās internetbankas lietotāja ID',
  'User ID for online banking': 'Lietotāja ID internetbankai',
  'User ID in the format XX000000': 'Lietotāja ID formātā XX000000',
  'User ID used to log in to the bank': 'Lietotāja ID, ko izmanto, lai pieteiktos bankā',
  'Username': 'Lietotājvārds',
  'Username used to log in to the bank': 'Lietotājvārds, ko izmanto, lai pieteiktos bankā',
  'VR NetKey': 'VR NetKey',
  'WebSSO user name': 'WebSSO lietotājvārds',
}
